import React, { useEffect } from 'react';
import { Button, Form, Input, Switch } from 'antd';
import { Controller, useForm } from 'react-hook-form';
import { Label } from 'reactstrap';
import { useAuth } from '../../Context/AuthContext';
import { toastSuccess, toastError, toastWarn } from '../Toast/ToastComponent';
import { QualificationApi } from '../../Api/QualificationApi';

const AddQualification = ({
  modalHeader,
  setModal,
  modal,
  getQualificationList,
  modalData,
  filterArr,
}) => {
  const { control, handleSubmit, reset, formState } = useForm({
    defaultValues: {
      qualification_name: '',
      status: true,
    },
  });

  const { errors } = formState;
  const { authState } = useAuth();

  useEffect(() => {
    if (modalData && modalData.id) {
      reset({
        qualification_name: modalData.title || '',
        status: modalData.status,
      });
    } else {
      reset({
        qualification_name: '',
        status: true,
      });
    }
  }, [modalData]);

  const isView =
    modalHeader?.props?.children === 'View Qualification';

  const onSubmit = async (data) => {
    try {
      const payload = {
        qualification_name: data.qualification_name,
        status: data.status,
      };

      const isEdit =
        modalHeader?.props?.children?.includes('Edit') &&
        modalData?.id;

      if (isEdit) {
        payload.id = modalData.id;
        payload.modified_By_ID = authState.id;

        const res = await QualificationApi.update(payload);

        if (res.data.success) {
          toastSuccess(res.data.message);
          await getQualificationList(filterArr);
          setModal(false);
        } else {
          toastWarn(res.data.message);
        }
      } else {
        payload.created_By_ID = authState.id;

        const res = await QualificationApi.createQualification(payload);

        if (res.data.success) {
          toastSuccess(res.data.message);
          await getQualificationList(filterArr);
          setModal(false);
        } else {
          toastWarn(res.data.message);
        }
      }
    } catch (err) {
      toastError('Something went wrong');
    }
  };

  return (
    <Form onFinish={handleSubmit(onSubmit)}>
      {/* NAME */}
      <Form.Item>
        <Label>
          Qualification <span style={{ color: 'red' }}>*</span>
        </Label>

        <Controller
          name="qualification_name"
          control={control}
          rules={{ required: 'Required' }}
          render={({ field }) => (
            <Input
              {...field}
              disabled={isView}   // 🔥 VIEW MODE DISABLE
              placeholder="Qualification"
            />
          )}
        />

        {errors?.qualification_name && (
          <p className="text-danger">
            {errors.qualification_name.message}
          </p>
        )}
      </Form.Item>

      {/* STATUS */}
      <Form.Item>
        <Controller
          name="status"
          control={control}
          render={({ field }) => (
            <Switch
              checked={field.value}
              disabled={isView}   // 🔥 VIEW MODE DISABLE
              onChange={field.onChange}
            />
          )}
        />
        <span className="ps-2">Active</span>
      </Form.Item>

      {/* BUTTONS */}
      {!isView && (
        <div className="d-flex justify-content-center">
          <Button onClick={() => setModal(!modal)}>Cancel</Button>
          <Button type="primary" htmlType="submit" className="ms-2">
            {modalHeader?.props?.children?.includes('Edit')
              ? 'Update'
              : 'Save'}
          </Button>
        </div>
      )}
    </Form>
  );
};

export default AddQualification;